import { InstitutionTypeFilter } from '../../services/adapters/queries/institutionsQueryFunction';

/**
 * Debe coincidir con la lógica de sync por URL (Results / TeacherProfile):
 * sin `type` en resultados o perfil de profe → "all" (sin filtro en API).
 * Home y el resto → university por defecto.
 */
export const getInitialSearchTypeFromLocation = (): InstitutionTypeFilter => {
  if (typeof window === 'undefined') {
    return 'university';
  }

  const { pathname, search } = window.location;
  const typeParam = new URLSearchParams(search).get('type');

  if (typeParam === 'languages' || typeParam === 'university' || typeParam === 'schools') {
    return typeParam;
  }

  const isTeacherProfile = /^\/teachers\/[^/]+\/profile\/?$/.test(pathname);
  const isTeachersResults = pathname === '/teachers' || pathname === '/teachers/';

  if (isTeacherProfile || isTeachersResults) {
    return 'all';
  }

  return 'university';
};
